import KendoAutoComplete from '../KendoAutoComplete'
import KendoDropDownList from '../KendoDropDownList'
import KendoComboBox from '../KendoComboBox'
import KendoMultiSelect from '../KendoMultiSelect'
import KendoMultiColumnComboBox from '../KendoMultiColumnComboBox'
import KendoMultiColumnComboBoxColumn from '../KendoMultiColumnComboBox/KendoMultiColumnComboBoxColumn'

let KendoDropdownsInstaller = class {
    static install(Vue) {
        Vue.component(KendoAutoComplete.name, KendoAutoComplete)
        Vue.component(KendoDropDownList.name, KendoDropDownList)
        Vue.component(KendoComboBox.name, KendoComboBox)
        Vue.component(KendoMultiSelect.name, KendoMultiSelect)
        Vue.component(KendoMultiColumnComboBox.name, KendoMultiColumnComboBox)
        Vue.component(KendoMultiColumnComboBoxColumn.name, KendoMultiColumnComboBoxColumn)
    }
}

export default KendoDropdownsInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(KendoDropdownsInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/kendo-dropdowns-installer/index.js